export class ArrayUtils {

    public static isAllTrue(array: boolean[]): boolean {
        for (let value of array) {
            if (!value) {
                return false;
            }
        }
        return true;
    }
}